/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const BoxNotes16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M11.328 1.792H1.168C.468 1.792 0 2.238 0 2.906c0 .67.467 1.115 1.168 1.115h8.525l1.635-2.23zM8.292 6.25H1.168C.468 6.25 0 6.696 0 7.365S.467 8.48 1.168 8.48h5.606l1.518-2.23zm-3.037 4.458H1.168c-.7 0-1.168.446-1.168 1.115s.467 1.115 1.168 1.115h2.92l.116-.335c.117-.223.117-.557.234-.78l.817-1.115zm7.475-6.8c.234.335.584.558.817.78.35.224.701.335 1.052.447l-5.723 8.249-.35.334-1.986 1.45c-.117.11-.233 0-.233-.112l.584-2.453c.116-.223.116-.334.233-.557L12.73 3.91zm1.518-2.34c.7-.223 1.518.111 1.752.78v.334c-.234.446-.35.78-.584 1.115l-1.051-.334c-.35-.223-.7-.446-.934-.892l.817-1.003z"
        />
    </AccessibleSVG>
);

export default BoxNotes16;
